<template>
  <div class="home">
    <ItemOne />
    <ItemTwo :tabs="tabs" />
    <ItemThree />
    <ItemFour />
    <ItemFive />
  </div>
</template>

<script>
import { getTabList } from '../../services'
import ItemOne from './itemOne'
import ItemTwo from './itemTwo'
import ItemThree from './itemThree'
import ItemFour from './itemFour'
import ItemFive from './itemFive'

export default {
  name: 'home',
  components: {
    ItemOne,
    ItemTwo,
    ItemThree,
    ItemFour,
    ItemFive
  },

  data () {
    return {
      tabs: []
    }
  },

  created () {
    const items = document.getElementsByClassName('item')
    const tabs = document.getElementsByClassName('tabs')

    getTabList().then(res => {
      this.tabs = res.data.data.data.children
    })

    document.addEventListener('scroll', function () {
      var visibleBottom = window.scrollY + document.documentElement.clientHeight;
      for (var i = 0; i < items.length; i++) {
          var centerY = items[i].offsetTop
          if (centerY < visibleBottom) {
              items[i].setAttribute("class", 'item animate');
          } else {
              items[i].setAttribute("class", 'item');
          }
      }

      for (var j = 0; j < tabs.length; j++) {
          var centerY1 = tabs[j].offsetTop
          if (centerY1 < visibleBottom) {
              tabs[j].setAttribute("class", 'tabs animate');
          } else {
              tabs[j].setAttribute("class", 'tabs');
          }
      }
    });
  },

  mounted () {
    const items = document.getElementsByClassName('item')

    var visibleBottom = window.scrollY + document.documentElement.clientHeight;
    for (var i = 0; i < items.length; i++) {
        var centerY = items[i].offsetTop
        if (centerY < visibleBottom) {
            items[i].setAttribute("class", 'item animate');
        } else {
            items[i].setAttribute("class", 'item');
        }
    }
  }
}
</script>

<style lang="less">
  .home {
    .item {
      margin-top: 70px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-header {
        &-title {
          color: rgba(34, 34, 34, .1);
          font-size: 15px;
          transform: translateX(100px);
          transition: all .5s ease-in-out;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 22.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 30px;
          }
        }

        &-name {
          font-size: 24px;
          padding: 4px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all .5s ease-in-out;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 36px;
            padding: 6px 0px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 48px;
            padding: 8px 0px;
          }

          &-line {
            width: 60px;
            height: 2px;
            background: rgba(34, 34, 34, .1);
            display: inline-block;
            margin: 0px 16px;

            @media (min-width: 1280px) and (max-width: 1680px){
              width: 90px;
              height: 3px;
              margin: 0px 24px;
            }
                  
            @media screen and (min-width: 1920px){
              width: 120px;
              height: 4px;
              margin: 0 32px;
            }


          }
          .bold {
            font-weight: bold;
          }
        }

        &-desc {
          color: #959595;
          font-size: 9px;
          transform: translateX(-100px);
          transition: all .5s ease-in-out;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 13.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 18px;
          }
        }
      }

      &-content {
        margin-top: 20px;

        @media (min-width: 1280px) and (max-width: 1680px){
          margin-top: 30px;
        }
              
        @media screen and (min-width: 1920px){
          margin-top: 40px;
        }
      }
    }

    .item.animate {
      .item-header {
        &-title {
          transform: translateX(0px);
        }

        &-name {
          opacity: 1;
        }

        &-desc {
          transform: translateX(0px);
        }
      }
    }
  }
</style>